import { css, html, LitElement, PropertyValues } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { visibilityObserver, VisibilityObserverElement } from "../util/intersection";
import { sharedStyles } from "../styles/shared";
import { property } from "lit/decorators/property.js";

@customElement("bs-intersection-flip")
export class BsIntersectionFlip extends LitElement implements VisibilityObserverElement {
	@property({ type: Boolean, reflect: true }) intersecting = false;
	@property({ type: Boolean, reflect: true }) transition = false;

	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: block;
				}

				:host([transition]) {
					transition: var(--intersection-flip-transition, opacity 500ms ease-out, transform 500ms ease-out);
					transition-delay: var(--intersection-flip-transition-delay, 0ms);
					transform: var(--intersection-flip-transform-from, translateY(-30px));
					opacity: 0;
				}

				:host([transition][intersecting]) {
					transform: var(--intersection-flip-transform-to, translateY(0));
					opacity: 1;
				}
			`
		];
	}

	protected firstUpdated(props: PropertyValues) {
		super.firstUpdated(props);
		this.observe();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		this.unobserve();
	}

	observe() {
		visibilityObserver.observe(this);
	}

	unobserve() {
		visibilityObserver.unobserve(this);
	}

	visibilityChanged(visible: boolean) {
		this.intersecting = visible;
		if (visible) {
			this.unobserve();
		}
	}

	render() {
		return html`<slot></slot>`;
	}
}
